import React from 'react';
import { useCookieConsent } from '@hooks/useCookieConsent';
import styles from './CookieConsentManager.module.css';
import 'klaro/dist/klaro.min.css';

export const CookieConsentManager = () => {
    const { manageButtonLabel, openManager, shouldDisplayTrigger, shouldRender } = useCookieConsent();

    if (!shouldRender) {
        return null;
    }

    if (!shouldDisplayTrigger) {
        return null;
    }

    return (
        <button type="button" className={styles.manageButton} aria-label={manageButtonLabel} onClick={openManager}>
            <span className={styles.icon} aria-hidden="true">
                <i className="fa-solid fa-cookie-bite" />
            </span>
        </button>
    );
};
